import axios from 'axios';
import { API_BASE } from './config';

/**
 * Fetch all networks
 * @returns List of networks
 */
export const fetchNetworks = async () => {
  try {
    const response = await axios.get(`${API_BASE}/network`);
    console.log('Network API raw response:', response);

    // Handle different response formats
    const data = response.data;

    // Log the response data for debugging
    console.log('Network API response data:', data);

    // Return the data in a consistent format
    if (data && data.data && Array.isArray(data.data)) {
      // Standard format with data property
      return data;
    } else if (Array.isArray(data)) {
      // If the response is already an array, wrap it in standard format
      return {
        data: data,
        status: true
      };
    } else if (data && data.networks && Array.isArray(data.networks)) {
      // If the response has a networks property that's an array
      return {
        data: data.networks,
        status: true
      };
    } else {
      // If we can't determine the format, return the raw data
      console.warn('Unknown network data format:', data);
      return {
        data: [],
        status: false,
        error: 'Invalid network data format'
      };
    }
  } catch (error: any) {
    console.error('Error fetching networks:', error);
    return {
      data: [],
      status: false,
      error: error.message || 'Failed to fetch networks'
    };
  }
};

/**
 * Fetch a network by ID
 * @param id Network ID
 * @returns Network details
 */
export const fetchNetworkById = async (id: string) => {
  try {
    const response = await axios.get(`${API_BASE}/network/${id}`);
    console.log('Network by ID response:', response.data);
    return response.data.data;
  } catch (error: any) {
    console.error(`Error fetching network with ID ${id}:`, error);
    throw error;
  }
};

/**
 * Create a new network
 * @param networkData Network data
 * @returns Created network
 */
export const createNetwork = async (networkData: any) => {
  try {
    const response = await axios.post(`${API_BASE}/network`, networkData);
    console.log('Create network response:', response.data);
    return response.data.data;
  } catch (error: any) {
    console.error('Error creating network:', error);
    throw error;
  }
};

/**
 * Update a network
 * @param id Network ID
 * @param networkData Updated network data
 * @returns Updated network
 */
export const updateNetwork = async (id: string, networkData: any) => {
  try {
    const response = await axios.put(`${API_BASE}/network/${id}`, networkData);
    console.log('Update network response:', response.data);
    return response.data.data;
  } catch (error: any) {
    console.error(`Error updating network with ID ${id}:`, error);
    throw error;
  }
};

/**
 * Delete a network
 * @param id Network ID
 * @returns Void
 */
export const deleteNetwork = async (id: string) => {
  try {
    await axios.delete(`${API_BASE}/network/${id}`);
    console.log(`Network with ID ${id} deleted successfully`);
  } catch (error: any) {
    console.error(`Error deleting network with ID ${id}:`, error);
    throw error;
  }
};
